export default __webpack_public_path__ + "static/media/Star.c4a21bd7.svg";